import Components from "./config/components";

export default [
  {
    name: "Loading",
    path: "/",
    component: Components.Loading
  },
  {
    name: "PrecompiledData",
    path: "/dati-personali",
    component: Components.PrecompiledData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PrecompiledDocument",
    path: "/patente",
    component: Components.PrecompiledDocument,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IdentityDocData",
    path: "/documento",
    component: Components.IdentityDocData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IncomeData",
    path: "/dati-reddito",
    component: Components.IncomeData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmployerData",
    path: "/dati-lavoro",
    component: Components.EmployerData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtection",
    path: "/protezione-pagamento",
    component: Components.LoanProtection,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtectionConsent",
    path: "/protezione-pagamento-consenso",
    component: Components.LoanProtectionConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "LoanProtectionWarning",
    path: "/protezione-pagamento-avviso",
    component: Components.LoanProtectionWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PersonalData",
    path: "/anagrafica-abitazione",
    component: Components.PersonalData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubConsent",
    path: "/club-platinum",
    component: Components.ClubConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubWarning",
    path: "/club-platinum-avviso",
    component: Components.ClubWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "Promo",
    path: "/promo",
    component: Components.Promo,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PromoConfirm",
    path: "/promo-confirm",
    component: Components.PromoConfirm,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PromoTerms",
    path: "/promo-terms",
    component: Components.PromoTerms,
    meta: {
      redirect: false,
    },
  },
  {
    name: "Typ",
    path: "/typ",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pp-club",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pp-ade",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pp-ade-club",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypMetlifeOK",
    path: "/metlife-ok",
    component: Components.TypMetlifeOK,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "RequestKO",
    path: "/ko",
    component: Components.RequestKO,
    meta: {
      resetState: true,
      redirect: false,
    },
  },
  {
    name: "RequestExpired",
    path: "/expired",
    component: Components.RequestExpired,
    meta: {
      resetState: true,
      redirect: false,
    },
  },
  {
    name: "RequestPending",
    path: "/pending",
    component: Components.RequestPending,
    meta: {
      resetState: true,
      redirect: false,
    },
  },
  {
    name: "MetlifeProtection",
    path: "/assicurazione-metlife",
    component: Components.MetlifeProtection,
    meta: {
      redirect: true,
    },
  },
  {
    name: "MetlifeProtectionConsent",
    path: "/assicurazione-metlife-consenso",
    component: Components.MetlifeProtectionConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "MetlifeProtectionWarning",
    path: "/assicurazione-metlife-avviso",
    component: Components.MetlifeProtectionWarning,
    meta: {
      redirect: true,
    },
  }
];
